module.exports = __webpack_public_path__ + "img/potencia_a.ec7a61de.svg";